export default (node) => {
  const selectType = node.querySelector('#select-type');
  const privateSubject = node.querySelector('#private-subject');
  const retailerSubject = node.querySelector('#retailer-subject');
  const otherSubject = node.querySelector('#other-subject');
  const orderQuestion = node.dataset.orderQuestion;
  const selectText = node.dataset.selectText;
  const form = node.querySelector('#contactForm');
  const thankYou = node.dataset.thankYou;
  const sorry = node.dataset.sorry;
  let n = 0;

  // Endpoints injected via data attributes on root container
  const privateEndpoint = node.dataset.privateEndpoint;
  const retailerEndpoint = node.dataset.retailerEndpoint;
  const otherEndpoint = node.dataset.otherEndpoint;

  const safeEndpoint = (url) => {
    if (!url) return null;
    if (url.indexOf('{{') > -1) return null; // Unrendered Liquid guard
    if (!/^https?:\/\//i.test(url)) return null;
    return url;
  };

  const handleSelectTypeChange = (e) => {
    node.querySelector('#questionOptions').classList.remove('hidden');
    const privateQuestionsWrapper = node.querySelector(
      '#private-questions-wrapper'
    );
    const retailerQuestionsWrapper = node.querySelector(
      '#retailer-questions-wrapper'
    );
    const otherQuestionsWrapper = node.querySelector(
      '#other-questions-wrapper'
    );
    n++;

    if (n > 1) {
      if (selectType.value == 'Private') {
        privateSubject.value = selectText;
        showHideElementsFunction(privateSubject);
      } else if (selectType.value == 'Retailer') {
        retailerSubject.value = selectText;
        showHideElementsFunction(retailerSubject);
      } else if (selectType.value == 'Other') {
        otherSubject.value = selectText;
        showHideElementsFunction(otherSubject);
      }
      orderStatusFunction();
    }

    if (selectType.value == 'Private') {
      form.action = safeEndpoint(privateEndpoint) || '';
      privateQuestionsWrapper.classList.remove('hidden');
      retailerQuestionsWrapper.classList.add('hidden');
      otherQuestionsWrapper.classList.add('hidden');
    } else if (selectType.value == 'Retailer') {
      form.action = safeEndpoint(retailerEndpoint) || '';
      privateQuestionsWrapper.classList.add('hidden');
      retailerQuestionsWrapper.classList.remove('hidden');
      otherQuestionsWrapper.classList.add('hidden');
    } else if (selectType.value == 'Other') {
      form.action = safeEndpoint(otherEndpoint) || '';
      privateQuestionsWrapper.classList.add('hidden');
      retailerQuestionsWrapper.classList.add('hidden');
      otherQuestionsWrapper.classList.remove('hidden');
    }
  };

  const handleizeString = (inputString) => {
    const trimmedString = inputString.trim();
    const handleizedString = trimmedString
      .replace(/[^a-zA-Z]+/g, '-')
      .toLowerCase();
    return handleizedString;
  };

  const orderStatusFunction = () => {
    const privateSubjectValue = handleizeString(privateSubject.value);
    const orderQuestionTranslation = handleizeString(orderQuestion);
    const orderField = node.querySelector('#field-order-number');

    if (privateSubjectValue == orderQuestionTranslation) {
      orderField.classList.remove('hidden');
    } else {
      orderField.classList.add('hidden');
    }
  };

  const showHideElementsFunction = (subjectElement) => {
    const selectedQuestionHandle =
      subjectElement.selectedOptions[0].classList[0];
    const selectedQuestionHandleText = '#' + selectedQuestionHandle + '-true';

    const hideDivs = () => {
      for (const element of node.querySelectorAll(
        '[data-form-override-question]'
      )) {
        element.classList.add('hidden');
      }
    };

    if (node.querySelector(selectedQuestionHandleText)) {
      hideDivs();
      node.querySelector('#hide-when-message').classList.add('hidden');
      node.querySelector(selectedQuestionHandleText).classList.remove('hidden');
    } else {
      hideDivs();
      node.querySelector('#hide-when-message').classList.remove('hidden');
    }
  };

  async function handleSubmit(event) {
    event.preventDefault();
    const status = node.querySelector('#formStatus');
    const endpoint = form.action;
    if (!endpoint) {
      status.innerHTML = sorry;
      console.error('[contact-form] No endpoint set for current selection');
      return;
    }
    if (endpoint.indexOf('{{') > -1) {
      status.innerHTML = sorry;
      console.error('[contact-form] Endpoint contains unresolved Liquid placeholder');
      return;
    }
    const data = new FormData(event.target);

    // Ensure subject uses the option text (not the value) to avoid truncation with apostrophes/accents
    try {
      let subjectSelect = null;
      const typeVal = selectType?.value;
      if (typeVal === 'Private') subjectSelect = privateSubject;
      else if (typeVal === 'Retailer') subjectSelect = retailerSubject;
      else if (typeVal === 'Other') subjectSelect = otherSubject;
      if (!subjectSelect) subjectSelect = node.querySelector('select[name="subject"]');

      const selectedOpt = subjectSelect?.selectedOptions?.[0];
      const subjectText = selectedOpt?.textContent?.trim();
      if (subjectText) {
        data.set('subject', subjectText);
      }
    } catch (e) {
      console.warn('[contact-form] Failed to override subject text', e);
    }
    let response;
    try {
      response = await fetch(endpoint, {
        method: form.method,
        body: data,
        headers: { Accept: 'application/json' },
      });
    } catch (networkErr) {
      console.error('[contact-form] Network error', networkErr);
      status.innerHTML = sorry;
      return;
    }

    const contentType = response.headers.get('content-type') || '';
    const canParseJSON = contentType.includes('application/json');

    if (response.ok) {
      let payload = null;
      if (canParseJSON) {
        try { payload = await response.json(); } catch (_) {}
      }
      status.innerHTML = thankYou;
      form.reset();
      setTimeout(() => window.location.reload(), 1500);
      return;
    }

    // Error path
    if (canParseJSON) {
      try {
        const errData = await response.json();
        if (errData && errData.errors) {
          status.innerHTML = errData.errors.map(e => e.message || e).join(', ');
          return;
        }
      } catch (_) { /* swallow */ }
    }
    status.innerHTML = sorry;
  }

  // Expose reCAPTCHA callback globally so data-callback="onSubmit" can invoke it
  window.onSubmit = (token) => {
    try {
      const btn = node.querySelector('#formButton');
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('is-disabled');
      }
      const recaptchaConfirmation = node.querySelector('#recaptchaConfirmation');
      if (recaptchaConfirmation) recaptchaConfirmation.value = 'form_is_valid';
    } catch (e) {
      console.error('reCAPTCHA onSubmit error', e);
    }
  };

  const init = () => {
    selectType.addEventListener('change', handleSelectTypeChange);
    privateSubject.addEventListener('change', (event) => {
      showHideElementsFunction(privateSubject);
      orderStatusFunction();
    });
    retailerSubject.addEventListener('change', (event) => {
      showHideElementsFunction(retailerSubject);
      orderStatusFunction();
    });

    otherSubject.addEventListener('change', (event) => {
      showHideElementsFunction(otherSubject);
      orderStatusFunction();
    });

    // Ensure button starts disabled explicitly (in case snippet changes)
    const btn = node.querySelector('#formButton');
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-disabled');
    }

    form.addEventListener('submit', (e) => {
      const recaptchaConfirmation = node.querySelector('#recaptchaConfirmation');
      if (!recaptchaConfirmation || recaptchaConfirmation.value !== 'form_is_valid') {
        e.preventDefault();
        console.warn('[contact-form] Attempted submit before reCAPTCHA validation');
        return;
      }
      // Show spinner state
      if (btn) {
        btn.disabled = true;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        // Preserve original label
        if (!btn.dataset.originalText) btn.dataset.originalText = btn.innerHTML;
  btn.innerHTML = '<span class="inline-flex items-center gap-2"><span class="w-4 h-4 border-2 border-current border-r-transparent rounded-full animate-spin motion-reduce:animate-none"></span><span>' + (btn.dataset.originalText || '') + '</span></span>';
      }
      handleSubmit(e).finally(() => {
        // On success we reload soon; on error re-enable button
        setTimeout(() => {
          const status = node.querySelector('#formStatus');
          if (btn && !status.innerHTML.includes(thankYou)) {
            btn.disabled = false;
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
            if (btn.dataset.originalText) btn.innerHTML = btn.dataset.originalText;
          }
        }, 1200);
      });
    });
  };

  init();
};
